import { useMutation } from "@tanstack/react-query";
import { recalculateAllPrices, unlockApp, type RecalculateAllBody } from "@/api/adminService";
import { useQueryInvalidation } from "@/lib/queryInvalidation";

export const useRecalculateAllPrices = () => {
  const invalidate = useQueryInvalidation();

  return useMutation({
    mutationFn: (data: RecalculateAllBody) => recalculateAllPrices(data),
    onSuccess: () => {
      invalidate.invalidateAll();
    },
  });
};

export const useUnlockApp = () => {
  return useMutation({
    mutationFn: unlockApp,
  });
};
